"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitTitle = void 0;
function splitTitle(fullTitle) {
    if (!fullTitle)
        return { title: undefined, preTitle: undefined };
    const preTitleBits = (fullTitle || '').split(' > ');
    if (!preTitleBits.length)
        return { title: fullTitle, preTitle: undefined };
    const title = preTitleBits.pop();
    return {
        title,
        preTitle: preTitleBits.length ? preTitleBits.join(' > ') : undefined,
    };
}
exports.splitTitle = splitTitle;
exports.default = splitTitle;
